/** Posición en pentagrama (líneas) y solfeo para render ilustrado. */
export const NOTE_STAFF_LINE = {
  C: 4,
  D: 3.5,
  E: 3,
  F: 2.5,
  G: 2,
  A: 1.5,
  B: 1,
};

export const NOTE_SOLFEGE = {
  C: 'Do',
  D: 'Re',
  E: 'Mi',
  F: 'Fa',
  G: 'Sol',
  A: 'La',
  B: 'Si',
};

export const MATCH_GLOW = {
  'Octave Match': { color: '#FDE047', label: 'Octava' },
  'Triad Match': { color: '#C084FC', label: 'Tríada' },
  'Tetracord Match': { color: '#67E8F9', label: 'Tetracord' },
  'Scale Match': { color: '#FB923C', label: 'Escala' },
};

/** Configuración de la escala actual (Do Mayor) y colores pastel arcoíris. */
export const CURRENT_SCALE = {
  id: 'C_MAJOR',
  name: 'Do Major',
  notes: ['C', 'D', 'E', 'F', 'G', 'A', 'B'],
  colors: ['#EF4444', '#FACC15', '#3B82F6', '#22C55E', '#8B5CF6', '#F97316', '#06B6D4'],
};

export const SCALE_OCTAVE = [...CURRENT_SCALE.notes, 'C'];

export const DIATONIC_TRIADS = [
  ['C', 'E', 'G'],
  ['D', 'F', 'A'],
  ['E', 'G', 'B'],
  ['F', 'A', 'C'],
  ['G', 'B', 'D'],
  ['A', 'C', 'E'],
  ['B', 'D', 'F'],
];

export const TETRACORDS = [];
for (let i = 0; i <= CURRENT_SCALE.notes.length - 4; i++) {
  TETRACORDS.push(CURRENT_SCALE.notes.slice(i, i + 4));
}

export const SCORE_VALUES = {
  octave: 100,
  triad: 300,
  tetracord: 500,
  scale: 2000,
};

export function noteColor(note) {
  const idx = CURRENT_SCALE.notes.indexOf(note);
  return idx >= 0 ? CURRENT_SCALE.colors[idx] : '#E2E8F0';
}

export function randomScaleNote() {
  const idx = Math.floor(Math.random() * CURRENT_SCALE.notes.length);
  return CURRENT_SCALE.notes[idx];
}

export function sequenceMatchesPattern(seq, pattern) {
  if (seq.length !== pattern.length) return false;
  const forward = pattern.every((n, i) => seq[i] === n);
  const backward = pattern.every((n, i) => seq[seq.length - 1 - i] === n);
  return forward || backward;
}
